import { useContext } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import useClienteController from "../controllers/ClienteController";
import { ClienteContext } from "../contexts/ClienteContext";
import Fieldset from "../../../../components/basics/Fieldset";
import Card from "../../../../components/cards/Card";
import { HeaderAccordion } from "../styles/Cliente";
import Chip from "../../../../components/basics/Chip";

export default function AccordionClienteOutrasInfo() {
  const {
    otherBirthDate,
    setOtherBirthDate,
    otherFathersName,
    setOtherFathersName,
    otherRgFather,
    setOtherRgFather,
    otherCpfFather,
    setOtherCpfFather,
    otherMothersName,
    setOtherMothersName,
    otherRgMother,
    setOtherRgMother,
    otherCpfMother,
    setOtherCpfMother,
    otherAdditionalData,
    setOtherAdditionalData,
    otherCompanyName,
    setOtherCompanyName,
    otherIssueDate,
    setOtherIssueDate,
    otherRemuneration,
    setOtherRemuneration,
    otherRole,
    setOtherRole,
    otherTelephone,
    setOtherTelephone,
    otherCounty,
    setOtherCounty,
    otherAddress,
    setOtherAddress,
    otherTypeResidence,
    setOtherTypeResidence,
    otherTimeResidence,
    setOtherTimeResidence,
    otherFamilyIncome,
    setOtherFamilyIncome,
    otherPersonalReference,
    setOtherPersonalReference,
    otherCommercialReference,
    setOtherCommercialReference,
    otherNoteNfe,
    setOtherNoteNfe,

    //Dados do Cônjuge
    spousesName,
    setSpousesName,
    spousesBirthDate,
    setSpousesBirthDate,
    spousesTelephone,
    setSpousesTelephone,
    spousesRg,
    setSpousesRg,
    spousesCpf,
    setSpousesCpf,
    spousesCompany,
    setSpousesCompany,
    spousesAdmissionDate,
    setspousesAdmissionDate,
    spousesRole,
    setSpousesRole,
    spousesRemuneration,
    setSpousesRemuneration,
    spousesCounty,
    setSpousesCounty,
    spousesAddress,
    setSpousesAddress,

    loadingInputs,
    expanded,
    listCounty,
    errors,
  } = useContext(ClienteContext);
  const { handleChangeOpenAcordion } = useClienteController();

  return (
    <>
      <Grid item xs={12}>
        <Accordion
          expanded={expanded.othersInfo || false}
          onChange={() => handleChangeOpenAcordion("othersInfo")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container>
                <Grid item xs={12}>
                  <Chip
                    label="OUTRAS INFORMAÇÕES (PESSOA FÍSICA)"
                    bgcolor={
                      !expanded.othersInfo &&
                      errors.accordions &&
                      errors.accordions.includes("othersInfo")
                        ? "red"
                        : "default"
                    }
                    textcolor={
                      !expanded.othersInfo &&
                      errors.accordions &&
                      errors.accordions.includes("othersInfo")
                        ? "white"
                        : "default"
                    }
                  />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={3}>
              <Grid item sm={6} xs={12}>
                <Card line="left">
                  <Grid container spacing={2}>
                    <Grid item lg={4} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        helperText={errors.otherBirthDate || ""}
                        error={errors.otherBirthDate ? true : false}
                        label="Data de Nascimento"
                        value={otherBirthDate}
                        setValue={setOtherBirthDate}
                        type="date"
                      />
                    </Grid>

                    <Grid item lg={3} md={6} sm={12} xs={12}>
                      <SelectErp
                        loading={false}
                        helperText={errors.otherTypeResidence || ""}
                        error={errors.otherTypeResidence ? true : false}
                        label="Tipo Residência"
                        value={otherTypeResidence}
                        setValue={setOtherTypeResidence}
                        optionsList={[
                          { label: "Própria", value: "P" },
                          { label: "Alugada", value: "A" },
                          { label: "Outro", value: "O" },
                        ]}
                        descriptionField="label"
                      />
                    </Grid>

                    <Grid item lg={4} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        label="Tempo na Residência"
                        maxLength={30}
                        value={otherTimeResidence}
                        setValue={setOtherTimeResidence}
                      />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextFieldErp
                        label="Nome do Pai"
                        maxLength={50}
                        value={otherFathersName}
                        setValue={setOtherFathersName}
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        helperText={errors.otherRgFather || ""}
                        error={errors.otherRgFather ? true : false}
                        label="RG do Pai"
                        maxLength={20}
                        value={otherRgFather}
                        setValue={setOtherRgFather}
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        helperText={errors.otherCpfFather || ""}
                        error={errors.otherCpfFather ? true : false}
                        label="CPF do Pai"
                        value={otherCpfFather}
                        setValue={setOtherCpfFather}
                        mask="cpf"
                      />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextFieldErp
                        label="Nome da Mãe"
                        maxLength={50}
                        value={otherMothersName}
                        setValue={setOtherMothersName}
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        helperText={errors.otherRgMother || ""}
                        error={errors.otherRgMother ? true : false}
                        label="RG da Mãe"
                        maxLength={20}
                        value={otherRgMother}
                        setValue={setOtherRgMother}
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        helperText={errors.otherCpfMother || ""}
                        error={errors.otherCpfMother ? true : false}
                        label="CPF da Mãe"
                        value={otherCpfMother}
                        setValue={setOtherCpfMother}
                        mask="cpf"
                      />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextFieldErp
                        label="Dados Adicionais"
                        maxLength={255}
                        value={otherAdditionalData}
                        setValue={setOtherAdditionalData}
                        multiline
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item sm={6} xs={12}>
                <Card line="left">
                  <Grid container spacing={2}>
                    <Grid item lg={8} md={12} sm={12} xs={12}>
                      <TextFieldErp
                        label="Nome da Empresa"
                        maxLength={100}
                        value={otherCompanyName}
                        setValue={setOtherCompanyName}
                      />
                    </Grid>

                    <Grid item lg={4} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        helperText={errors.otherIssueDate || ""}
                        error={errors.otherIssueDate ? true : false}
                        label="Data Admissão"
                        value={otherIssueDate}
                        setValue={setOtherIssueDate}
                        type="date"
                      />
                    </Grid>

                    <Grid item lg={4} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        label="Salário"
                        maxLength={13}
                        value={otherRemuneration}
                        setValue={setOtherRemuneration}
                        mask="decimal"
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        label="Renda Familiar"
                        value={otherFamilyIncome}
                        setValue={setOtherFamilyIncome}
                        mask="decimal"
                        maxLength={13}
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        label="Função"
                        maxLength={50}
                        value={otherRole}
                        setValue={setOtherRole}
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        helperText={errors.otherTelephone || ""}
                        error={errors.otherTelephone ? true : false}
                        label="Telefone"
                        value={otherTelephone}
                        setValue={setOtherTelephone}
                        mask="cel-phone"
                      />
                    </Grid>

                    <Grid item lg={8} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        label="Endereço"
                        maxLength={100}
                        value={otherAddress}
                        setValue={setOtherAddress}
                      />
                    </Grid>

                    <Grid item lg={4} md={6} sm={12} xs={12}>
                      <SelectErp
                        loading={loadingInputs.listCounty || false}
                        label="Município"
                        value={otherCounty}
                        setValue={setOtherCounty}
                        optionsList={listCounty}
                        descriptionField="municipio"
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        label="Referência Pessoal"
                        maxLength={255}
                        value={otherPersonalReference}
                        setValue={setOtherPersonalReference}
                      />
                    </Grid>

                    <Grid item lg={6} md={12} sm={12} xs={12}>
                      <TextFieldErp
                        label="Referência Comercial"
                        maxLength={255}
                        value={otherCommercialReference}
                        setValue={setOtherCommercialReference}
                      />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextFieldErp
                        label="Observação para NF-e"
                        maxLength={255}
                        value={otherNoteNfe}
                        setValue={setOtherNoteNfe}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Fieldset
                  titulo="Dados do Cônjuge"
                  bgcolor="secondary"
                  textcolor="black"
                >
                  <Grid container spacing={2}>
                    <Grid item lg={3} md={4} sm={6} xs={12}>
                      <TextFieldErp
                        helperText={errors.spousesCpf || ""}
                        error={errors.spousesCpf ? true : false}
                        label="CPF"
                        value={spousesCpf}
                        setValue={setSpousesCpf}
                        mask="cpf"
                      />
                    </Grid>

                    <Grid item lg={3} md={4} sm={6} xs={12}>
                      <TextFieldErp
                        helperText={errors.spousesRg || ""}
                        error={errors.spousesRg ? true : false}
                        label="RG"
                        maxLength={20}
                        value={spousesRg}
                        setValue={setSpousesRg}
                      />
                    </Grid>

                    <Grid item lg={6} md={8} sm={12} xs={12}>
                      <TextFieldErp
                        label="Nome do Cônjuge"
                        maxLength={50}
                        value={spousesName}
                        setValue={setSpousesName}
                      />
                    </Grid>

                    <Grid item lg={3} md={4} sm={6} xs={12}>
                      <TextFieldErp
                        helperText={errors.spousesBirthDate || ""}
                        error={errors.spousesBirthDate ? true : false}
                        label="Data de Nascimento"
                        value={spousesBirthDate}
                        setValue={setSpousesBirthDate}
                        type="date"
                      />
                    </Grid>

                    <Grid item lg={3} md={4} sm={6} xs={12}>
                      <TextFieldErp
                        helperText={errors.spousesTelephone || ""}
                        error={errors.spousesTelephone ? true : false}
                        label="Telefone"
                        value={spousesTelephone}
                        setValue={setSpousesTelephone}
                        mask="cel-phone"
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        label="Empresa"
                        maxLength={100}
                        value={spousesCompany}
                        setValue={setSpousesCompany}
                      />
                    </Grid>

                    <Grid item lg={4} md={3} sm={6} xs={12}>
                      <TextFieldErp
                        helperText={errors.spousesAdmissionDate || ""}
                        error={errors.spousesAdmissionDate ? true : false}
                        label="Data de Admissão"
                        value={spousesAdmissionDate}
                        setValue={setspousesAdmissionDate}
                        type="date"
                      />
                    </Grid>

                    <Grid item lg={4} md={3} sm={6} xs={12}>
                      <TextFieldErp
                        label="Função"
                        maxLength={50}
                        value={spousesRole}
                        setValue={setSpousesRole}
                      />
                    </Grid>

                    <Grid item lg={4} md={3} sm={6} xs={12}>
                      <TextFieldErp
                        label="Salário"
                        maxLength={13}
                        value={spousesRemuneration}
                        setValue={setSpousesRemuneration}
                        mask="decimal"
                      />
                    </Grid>

                    <Grid item lg={6} md={4} sm={6} xs={12}>
                      <SelectErp
                        error={errors.spousesCounty ? true : false}
                        helperText={errors.spousesCounty || ""}
                        loading={loadingInputs.listCounty || false}
                        label="Município"
                        value={spousesCounty}
                        setValue={setSpousesCounty}
                        optionsList={listCounty}
                        descriptionField="municipio"
                      />
                    </Grid>

                    <Grid item lg={6} md={5} sm={12} xs={12}>
                      <TextFieldErp
                        label="Endereço"
                        maxLength={100}
                        value={spousesAddress}
                        setValue={setSpousesAddress}
                      />
                    </Grid>
                  </Grid>
                </Fieldset>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
